import { useQuery } from '@tanstack/react-query';
import { http, returnIfNotFoundError } from 'services/http';
import { CARGO_ITEMS_MANY } from 'api/query-keys.ts';
import type { CargoItemRes } from 'api/swagger';
import type { WithPagination } from 'shared/utils/pagination.ts';
import { preparePagination } from 'shared/utils/pagination.ts';

interface IParams {
  cargoId?: number;
}

export const useGetCargoItems = (params?: IParams) => {
  const { cargoId } = params || {};

  return useQuery<WithPagination<CargoItemRes[]>>({
    queryKey: [CARGO_ITEMS_MANY, cargoId],
    queryFn: async () => {
      try {
        const { data, headers } = await http.get<CargoItemRes[]>(`/v1/cargo/${cargoId}/cargo-items`);
        const pagination = preparePagination(headers);

        return { data, pagination };
      } catch (error) {
        return returnIfNotFoundError<WithPagination<[]>>(error, { data: [], pagination: null });
      }
    },
    retry: false,
    refetchOnWindowFocus: false,
    staleTime: 30 * 1000,
    cacheTime: 60 * 1000,
    enabled: !!cargoId,
  });
};
